<template>
  <div id="not-found">
    <div class="backdrop">
      <div class="img-container">
        <img src="../assets/bg-intro.png" :style=setPos alt="">
      </div>
    </div>
    <div class="intro-text">
        <h1>{{ $t('error.notFound.title') }}</h1>
        <h1>{{ $t('error.notFound.message') }}</h1>
    </div>
  </div>
</template>

<script>
import common from '@/utils/common';

export default {
  name: 'not-found',
  mixins: [
    common,
  ],
  computed: {
    setPos() {
      const docHeight = this.docHeight;
      const docWidth = this.docWidth;
      let marginValue = '';
      if (docHeight > docWidth) {
        const marginCal = (docHeight - docWidth) / 2;
        marginValue = `-${marginCal}px`;
        return {
          'margin-left': marginValue,
          width: 'auto',
          height: '100%',
        };
      }
      if (docHeight < docWidth) {
        const marginCal = (docWidth - docHeight) / 2;
        marginValue = `-${marginCal}px`;
        return {
          'margin-top': marginValue,
          width: '100%',
          height: 'auto',
        };
      }
      return {
        width: '100%',
        height: 'auto',
      };
    },
  },
};
</script>

<style lang="scss" src="../scss/not-found.scss"></style>



// WEBPACK FOOTER //
// src/views/not-found.vue